import _ from 'lodash';
import moment from 'moment';

class InvoiceTimeEntryModalController {
  constructor($scope, $uibModalInstance, $http, $rootScope) {
      "ngInject";
      this.name = 'ConfirmModal';

      $scope.title = $uibModalInstance.title;
      $scope.subject = $uibModalInstance.subject;
      $scope.message = $uibModalInstance.message;

      $scope.invoice = $uibModalInstance.invoice;

      $scope.userId = $uibModalInstance.userId;
      $scope.chargeCodeId = $uibModalInstance.chargeCodeId;

      $scope.employee = $uibModalInstance.employee;
      $scope.chargeCode = $uibModalInstance.chargeCode;
      $scope.lineItem  = $uibModalInstance.lineItem;
      $scope.uninvoicedEntries = $uibModalInstance.uninvoicedEntries;


      $scope.addToInvoice = function () {
        let x = _.filter($scope.timeEntries, (obj) => {
          return obj.selected;
        });

        $scope.lineItem.timeEntries = x;
        $uibModalInstance.success();
      };

      $scope.cancel = function () {
        $uibModalInstance.cancel();
      };

      $scope.selectAll = function() {
        $scope.allSelected = !$scope.allSelected;
        $scope.timeEntries.forEach((entry) => {
          entry.selected = $scope.allSelected;
        });
      };

      $scope.getTotalHours = function() {
        let hours = 0;
        if($scope.timeEntries) {
          $scope.timeEntries.forEach((entry) => {
            hours += entry.hours;
          });
        }
        return hours;
      };


        let entriesForEmployee = _.filter($scope.uninvoicedEntries, (obj) => {
          let x = obj.employeeId == $scope.userId;
          let y = obj.chargeCode.id == $scope.chargeCodeId;
          let z = moment(obj.date).isSameOrAfter($scope.invoice.invoicePeriodStart) && moment(obj.date).isSameOrBefore($scope.invoice.invoicePeriodEnd)
          return x && y && z;
        });

        if($scope.lineItem.timeEntries) {
          //for each entry
          $scope.lineItem.timeEntries.forEach((entry) => {
            entriesForEmployee.forEach((obj) => {
              let x = obj.date == entry.date && obj.hours == entry.hours && obj.chargeCode.id == entry.chargeCode.id;
              if(x) {
                obj.selected = true;
              }
            });
          });
        }

        $scope.timeEntries = entriesForEmployee;



  }





}

export default InvoiceTimeEntryModalController;



// WEBPACK FOOTER //
// ./client/common/modals/InvoiceTimeEntryModal/invoiceTimeEntryModal.controller.js